import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';

/**
 * @description
 * Guard to redirect from old 'mill-asset-intelligence' routes to new 'pulp-&-paper-intelligence' routes.
 * replaces 'mill-asset-intelligence' with 'pulp-&-paper-intelligence' in the URL and navigates to the new route.
 * If the URL does not start with 'mill-asset-intelligence', navigation is allowed to proceed.
 *
 * @returns
 * returns false if a redirection occurs, true otherwise.
 */
@Injectable({
    providedIn: 'root'
})
export class PaperRedirectGuard  {
    public constructor(private router: Router) { }

    public canActivate(route: ActivatedRouteSnapshot): boolean {
        const url = route.url.map(segment => segment.path).join('/');
        if (url.startsWith('mill-asset-intelligence')) {
            const newUrl = url.replace('mill-asset-intelligence', 'pulp-&-paper-intelligence');
            
            // Preserve query parameters and fragments
            const queryParams = route.queryParams;
            const fragment = route.fragment;
            void this.router.navigate([`/${newUrl}`], { 
                queryParams: queryParams,
                fragment: fragment,
                replaceUrl: true 
            });
            return false;
        }
        return true;
    }
}